
// alert("Frontend CSS file has been updated with a new background color.");

import { initPcPerksSearch } from "./components/handle_search.js";
import { initPerksArchive } from "./components/perks_archive.js";
import { initSlidersInPage } from "./components/perks_slider.js";
import initSinglePage from "./single/single_page.js";


document.addEventListener("DOMContentLoaded", () => {
    initSinglePage();
    initSlidersInPage();
    initPcPerksSearch();
    initPerksArchive();
});